import { memo } from 'react'

import { useCueId } from '@/features/rundown/cue/cue.context'

import { Cell } from '../cell/Cell'
import { CellContext } from '../cell/cell.context'
import { makeCellKey } from '../cell/cell.schema.ts'
import { useColumnsDerived } from '../column/column.derived'

export const CueCellList = memo(function CueCellList() {
  const cueId = useCueId()
  const { visibleColumns } = useColumnsDerived()

  return visibleColumns.map((column) => {
    const cellKey = makeCellKey(cueId, column.id)

    return (
      <CellContext.Provider
        key={cellKey}
        value={cellKey}
      >
        <Cell />
      </CellContext.Provider>
    )
  })
})
